<template>
  <div class="service-goldprice">
    <h2>標準貴金屬重量計算方式</h2>
    <p>國際流通貴金屬﹝黃金、白銀﹞重量計算皆使用金衡制盎司，亦稱為英兩，單位金衡制盎司標準重量為31.1034768公克，與一般常用的常衡制盎司28.35公克並不相同。台灣傳統的貴金屬也常用台兩(37.5公克)計算，以下為貴金屬常用重量單位計算對照表：</p>
    <div id="table-container">
      <table id="fixed-unit">
        <tr>
          <th>單位</th>
        </tr>
        <tr>
          <td>公克</td>
        </tr>
        <tr>
          <td>台錢</td>
        </tr>
        <tr>
          <td>盎司</td>
        </tr>
        <tr>
          <td>台兩</td>
        </tr>
        <tr>
          <td>公斤</td>
        </tr>
      </table>
      <table id="scroll-table">
        <tr>
          <th>公克</th>
          <th>台錢</th>
          <th>盎司</th>
          <th>台兩</th>
          <th>公斤</th>
        </tr>
        <tr>
          <td>1</td>
          <td>0.26666</td>
          <td>0.03215</td>
          <td>0.26666</td>
          <td>0.001</td>
        </tr>
        <tr>
          <td>3.75</td>
          <td>1</td>
          <td>0.120565</td>
          <td>0.1</td>
          <td>0.00375</td>
        </tr>
        <tr>
          <td>31.1034768</td>
          <td>8.29426048</td>
          <td>1</td>
          <td>0.8294</td>
          <td>0.031103</td>
        </tr>
        <tr>
          <td>37.5</td>
          <td>10</td>
          <td>1.20565</td>
          <td>1</td>
          <td>0.0375</td>
        </tr>
        <tr>
          <td>1000</td>
          <td>266.66666</td>
          <td>32.15</td>
          <td>26.66666</td>
          <td>1</td>
        </tr>
      </table>
    </div>
    <div class="mobile_backNav" v-if="isMobileButtonShow">
      <i class="fa fa-angle-left"></i>
      <router-link to="/gold/service_mobile">返回說明與服務</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "serviceGoldprice",
  data() {
    return {
      isMobileButtonShow: false
    };
  },
  created() {
    let device = this.$store.getters.getDeviceSize;
    if (device < 585) {
      this.isMobileButtonShow = true;
    }
  }
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.service-goldprice {
  width: 66.73%;
  text-align: left;
  min-height: calc(100vh - 377px);
  h2 {
    font-size: 35px;
    font-weight: 600;
    letter-spacing: 2px;
    color: $primaryDeepColor;
    margin-top: 0;
  }
  p {
    font-size: 17px;
    color: $secondaryDeepColor1;
    line-height: 30px;
  }
}
.mobile_backNav {
  margin-top: 24px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    color: $primaryDeepColor;
    margin-right: 10px;
  }
  a {
    color: $primaryDeepColor;
  }
}
#table-container {
  width: 100%;
  overflow: auto;
}
#fixed-unit {
  position: absolute;
  background-color: $primaryLightColor;
  color: $secondaryColor3;
  font-weight: 600;
  td,
  th {
    width: 117px;
    height: 43px;
  }
}
#scroll-table {
  margin-left: 117px;
  table-layout: fixed;
  width: 800px;
  th {
    background-color: $primaryLightColor;
    color: $secondaryColor3;
    font-weight: 600;
  }
  td,
  th {
    width: 150px;
    height: 43px;
  }
}
table {
  border-collapse: collapse;
  color: $secondaryDeepColor1;
  text-align: center;
  border: 1px solid $primaryLightColor;
}
td,
th {
  border-bottom: 1px solid $primaryLightColor;
}
</style>
